export default __webpack_public_path__ + "static/media/carousel_cookies.5b8e3841.png";